import React, { Component } from 'react';

const $PLST = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/static`);

export default class Image extends Component {
  state = {
    imageError: false,
  };

  handleImageError = () => {
    this.setState({
      imageError: true,
    });
  };

  render() {
    const {
      classes,
      src,
      width,
      height,
      onClick,
      absoluteItem = null,
    } = this.props;
    const { imageError } = this.state;
    const isImageValid = src && !imageError;
    const isImageClickable = onClick && isImageValid;
    const imageClass = isImageClickable ? 'cursor-pointer' : 'cursor-auto';
    const image = isImageValid ? src : $PLST.NO_IMAGE;

    return (
      <div className={classes}>
        <img
          onClick={isImageClickable && onClick}
          onError={this.handleImageError}
          src={image}
          width={width}
          height={height}
          alt=''
          className={imageClass}
        />
        {absoluteItem}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/theme/Image.js